import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { ConstantService } from "../../../components/common/utils/constant.service";
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { Cliente } from "../../login/cliente_login";
import { ClienteLogin } from '../../../views/login/cliente_login';
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { ClienteEmpresaEntity } from "../datosGenerales/entities/datos_generales_empresa_entity";
import { ClienteIndividualEntity } from "../datosGenerales/entities/datos_generales_individual_entity";
import { SessionStorageService } from "ngx-webstorage";

declare var jQuery: any;

@Injectable()
export class ContactenosService {
    
    usuario: ClienteLogin;
    private url = "infoClienteIndividual";

    constructor(public authHttp: AuthHttp,private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }

    datosContactos(cliente: Cliente): Observable<any> {      
        let body = JSON.stringify(cliente);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarEjecutivos", body, options).map(this.extractData)
            .catch(this.handleError);
    }


    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/contactenos/contactenos.service.ts